export const strIsOnlyNumber = (value: string) => {
    const reg = /^\d+$/;
    return reg.test(value);
}